"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTDSGConsentService = void 0;
const types_1 = require("./types");
class TTDSGConsentService {
    constructor(ttdsgConsentClient, loggingFacade) {
        this.ttdsgConsentClient = ttdsgConsentClient;
        this.loggingFacade = loggingFacade;
    }
    checkIsConsentDue(documentsForVehicles) {
        let isConsentDue = false;
        if (!documentsForVehicles.length) {
            return isConsentDue;
        }
        for (const document of documentsForVehicles) {
            if (document.consentDecisionRequired) {
                isConsentDue = true;
                break;
            }
        }
        return isConsentDue;
    }
    getCurrentDecisions(documentsForVehicles) {
        let consentDocs = [];
        let decisions = [];
        documentsForVehicles.forEach((item) => {
            consentDocs = item.clusterDocuments ? item.documents.concat(item.clusterDocuments) : item.documents;
            consentDocs.forEach((doc) => {
                decisions.push({ vin: item.vin, consentDoc: doc });
            });
        });
        return decisions.map((item) => {
            var _a, _b;
            return ({
                vin: item.vin,
                versionDetailsId: item.consentDoc.versionDetails.id,
                decision: (_b = (_a = item.consentDoc.consent) === null || _a === void 0 ? void 0 : _a.decision) !== null && _b !== void 0 ? _b : false,
            });
        });
    }
    getFilteredDocumentsGroupedByVehicles(data) {
        return data
            .filter((vehicle) => vehicle.consentDecisionRequired)
            .map((vehicle) => (Object.assign(Object.assign({}, vehicle), { documents: vehicle.documents.filter((document) => document.consentDocumentDecisionRequired) })));
    }
    async getDocumentsConsentDecisionRequiredGroupedByVehicleV1(isWcar, userId) {
        try {
            return this.getFilteredDocumentsGroupedByVehicles(await this.ttdsgConsentClient.getDocumentConsentVehicleV1(isWcar, userId));
        }
        catch (error) {
            this.loggingFacade.error(`Could not fetch documents from ttdsg-consent`, error);
            throw new Error(error);
        }
    }
    async getDocumentsConsentDecisionRequiredGroupedByVehicleV2(isWcar, userId) {
        try {
            return this.getFilteredDocumentsGroupedByVehicles(await this.ttdsgConsentClient.getDocumentConsentVehicleV2(isWcar, userId));
        }
        catch (error) {
            this.loggingFacade.error(`Could not fetch documents from ttdsg-consent`, error);
            throw new Error(error);
        }
    }
    async getDocumentsGroupedByVehiclesV1(isWcar, userId, vehicles) {
        try {
            const data = await this.ttdsgConsentClient.getDocumentConsentVehicleV1(isWcar, userId);
            return data.map((item) => (Object.assign(Object.assign({}, item), { vehicle: vehicles.find((vehicle) => vehicle.vin === item.vin) })));
        }
        catch (error) {
            this.loggingFacade.error(`Could not fetch documents from ttdsg-consent`, error);
            throw new Error(error);
        }
    }
    async getDocumentsGroupedByVehiclesV2(isWcar, userId, vehicles) {
        try {
            const data = await this.ttdsgConsentClient.getDocumentConsentVehicleV2(isWcar, userId);
            return data.map((item) => (Object.assign(Object.assign({}, item), { vehicle: vehicles.find((vehicle) => vehicle.vin === item.vin) })));
        }
        catch (error) {
            this.loggingFacade.error(`Could not fetch documents from ttdsg-consent`, error);
            throw new Error(error);
        }
    }
    getAllDocuments(data) {
        if (!data)
            return [];
        const result = [];
        data.forEach((item) => {
            const processDocument = (docType) => {
                const documents = docType === types_1.DocType.CC ? item.clusterDocuments : item.documents;
                documents === null || documents === void 0 ? void 0 : documents.forEach((document) => {
                    result.push(Object.assign(Object.assign({ userId: item.userId, docType, consentDecisionRequired: item.consentDecisionRequired, consentDocumentDecisionRequired: document.consentDocumentDecisionRequired }, document.versionDetails), { vin: item.vin, consent: document.consent }));
                });
            };
            processDocument(types_1.DocType.TTDSG); // Process TTDSG documents
            processDocument(types_1.DocType.CC); // Process CC documents
        });
        return result;
    }
    getVinsByDocumentId(documentId, data) {
        const allDocuments = this.getAllDocuments(data);
        return allDocuments.filter((document) => document.id === documentId).map((documentVin) => documentVin.vin);
    }
    getVehiclesByDocumentId(documentId, vehicles, data) {
        const vins = this.getVinsByDocumentId(documentId, data);
        const result = [];
        vins.forEach((vin) => {
            const v = vehicles.find((v) => v.vin === vin);
            if (v) {
                result.push(v);
            }
        });
        return result;
    }
    async getDocumentByDocumentIdAndVin(documentId, vin, isWcar, userId) {
        try {
            const data = await this.ttdsgConsentClient.getDocumentConsentVehicleV2(isWcar, userId);
            for (const response of data) {
                if (response.vin === vin) {
                    for (const document of response.documents) {
                        if (document.documentId === documentId) {
                            return document;
                        }
                    }
                }
            }
            return null;
        }
        catch (error) {
            this.loggingFacade.error(`Could not fetch documents from ttdsg-consent`, error);
            throw new Error(error);
        }
    }
    async findConsentByDocumentIdAndVin(documentId, vin, isWcar, userId) {
        var _a;
        try {
            const document = await this.getDocumentByDocumentIdAndVin(documentId, vin, isWcar, userId);
            return ((_a = document === null || document === void 0 ? void 0 : document.consent) === null || _a === void 0 ? void 0 : _a.decision) || null;
        }
        catch (error) {
            this.loggingFacade.error(`Could not fetch documents from ttdsg-consent`, error);
            throw new Error(error);
        }
    }
    getUniqueDocuments(data, vehicles) {
        const allDocuments = this.getAllDocuments(data);
        const result = [];
        allDocuments.forEach((document) => {
            if (!result.some((item) => item.id === document.id)) {
                const { vin } = document, rest = __rest(document, ["vin"]);
                result.push(Object.assign(Object.assign({}, rest), { vehicles: this.getVehiclesByDocumentId(document.id, vehicles, data) }));
            }
        });
        return result;
    }
    async createConsents(payload, isWcar, userId) {
        for (const consent of payload) {
            try {
                await this.ttdsgConsentClient.createConsent(consent, isWcar, userId);
            }
            catch (error) {
                this.loggingFacade.error(`Could not fetch documents from ttdsg-consent`, error);
                throw new Error(error);
            }
        }
    }
    async updateConsent(consentID, decision, isWcar) {
        try {
            await this.ttdsgConsentClient.updateConsent(consentID, decision, isWcar);
        }
        catch (error) {
            this.loggingFacade.error(`Could not fetch documents from ttdsg-consent`, error);
            throw new Error(error);
        }
    }
    createDecisions(existingDecisions, newDecision) {
        const existingItem = existingDecisions.find((d) => d.versionDetailsId === newDecision.versionDetailsId && d.vin === newDecision.vin);
        if (existingItem) {
            existingItem.decision = newDecision.decision;
            return existingDecisions;
        }
        return existingDecisions.concat(newDecision);
    }
    createConsentPayload(initialData, decisions, decisionType, documentType) {
        const payload = [];
        function makeDecision(item, document) {
            var _a, _b;
            if (decisionType === types_1.DecisionType.ACCEPT_ALL)
                return true;
            if (decisionType === types_1.DecisionType.DECLINE_ALL)
                return false;
            return ((_b = (_a = decisions.find((decision) => decision.vin === item.vin && decision.versionDetailsId === document.versionDetails.id)) === null || _a === void 0 ? void 0 : _a.decision) !== null && _b !== void 0 ? _b : false);
        }
        if (documentType === types_1.DocType.TTDSG) {
            initialData.forEach((item) => {
                if (item.documents) {
                    payload.push({
                        userId: item.userId,
                        vin: item.vin,
                        consents: item.documents.map((document) => ({
                            versionDetailsId: document.versionDetails.id,
                            decision: makeDecision(item, document),
                        })),
                    });
                }
            });
        }
        else {
            initialData.forEach((item) => {
                if (item.clusterDocuments) {
                    payload.push({
                        userId: item.userId,
                        vin: item.vin,
                        consents: item.clusterDocuments &&
                            item.clusterDocuments.map((document) => ({
                                versionDetailsId: document.versionDetails.id,
                                decision: makeDecision(item, document),
                            })),
                    });
                }
            });
        }
        return payload;
    }
}
exports.TTDSGConsentService = TTDSGConsentService;
//# sourceMappingURL=ttdsgConsentService.js.map